var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"image-carousel-view"},[_c('carousel',_vm._l((_vm.images),function(image){return _c('carousel-slide',{key:image.id,staticClass:"glide-slide"},[_c('b-img',{attrs:{"src":image.src}})],1)}))],1)}
var staticRenderFns = []

export { render, staticRenderFns }